import { v4 as uuidv4 } from 'uuid';

import { IKnmErknmFormObject } from '../interfaces/IKnmErknmFormObject';

export const getInitialObject = (object?: IKnmErknmFormObject | undefined) => ({
  ...object,
  address: object?.address,
  objectType: object?.objectType,
  objectKind: object?.objectKind,
  objectSubKind: object?.objectSubKind,
  riskCategory: object?.riskCategory,
  dangerClass: object?.dangerClass,
  guid: object?.guid || undefined,
  ervkNumber: object?.ervkNumber || undefined,
  ervkId: object?.ervkId || undefined,
  cosId: object?.cosId || undefined,
  cosVersion: object?.cosVersion || undefined,
  name: object?.name || undefined,
  streetGuid: object?.streetGuid || undefined,
  houseGuid: object?.houseGuid || undefined,
  roomGuid: object?.roomGuid || undefined,
  steadGuid: object?.steadGuid || undefined,
  addressFns: object?.addressFns || undefined,
  autocomplete: typeof object?.autocomplete === 'boolean' ? object.autocomplete : undefined,
  dateCreate: object?.dateCreate || undefined,
  geolocation: object?.geolocation || undefined,
  listId: object?.listId || object?.guid || uuidv4(),
  isNew: object?.isNew || false,
  manualAddress: object?.manualAddress || undefined,
  notInFIAS: object?.notInFIAS || undefined,
  region: object?.region || undefined,
  fiasRegion: object?.fiasRegion || undefined,
  regionName: object?.regionName || undefined,
  isErrorFiasValue: object?.isErrorFiasValue || undefined,
  inspectionResults: object?.inspectionResults || undefined,
  organizationErvkId: object?.organizationErvkId || undefined,
  updating: object?.updating || undefined,
  isFilledFromLink: object?.isFilledFromLink || undefined,
});
